(function () {
  function getModal() {
    return document.querySelector('[data-e-gift-modal]');
  }

  function openModal() {
    const modal = getModal();
    if (!modal) return;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-e-gift-modal-open');
  }

  function closeModal() {
    const modal = getModal();
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-e-gift-modal-open');
  }

  function initTabs(modal) {
    const tabs = Array.from(modal.querySelectorAll('[data-e-gift-tab]'));
    const panels = Array.from(modal.querySelectorAll('[data-e-gift-panel]'));

    if (!tabs.length || !panels.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const current = tab.dataset.eGiftTab;

        tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.eGiftPanel === current;
          panel.hidden = !isActive;
        });
      });
    });
  }

  function isEgiftGuideTrigger(target) {
    const trigger = target.closest('a, button, [role="button"]');
    if (!trigger) return false;

    const text = (trigger.textContent || '').replace(/\s+/g, '');
    return text.includes('eギフトの贈り方はこちら');
  }

  function initModal() {
    const modal = getModal();
    if (!modal) return;

    const dialog = modal.querySelector('.e-gift-modal__dialog');
    const closeTargets = modal.querySelectorAll('[data-e-gift-modal-close]');

    closeTargets.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        closeModal();
      });
    });

    if (dialog) {
      dialog.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }

    modal.addEventListener('click', () => {
      closeModal();
    });

    document.addEventListener(
      'click',
      (event) => {
        if (!isEgiftGuideTrigger(event.target)) return;

        event.preventDefault();
        event.stopPropagation();
        openModal();
      },
      true
    );

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeModal();
      }
    });

    initTabs(modal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModal);
  } else {
    initModal();
  }
})();